// @flow

import styled, { css } from "styled-components";

import buildColor from "../../ColorPalette";

const GridHolder = styled.section`
  background-color: ${buildColor("blue", "100")};
  position: relative;
  display: flex;
  flex-grow: 1;
`;

const Grid = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 8px 8px 0;
  display: flex;
  flex-direction: row;
`;

const Column = styled.div`
  overflow: scroll;
  position: relative;
  overscroll-behavior: contain;
  ${(props) =>
    props.side === "left"
      ? css`
          width: 414px;
          flex-shrink: 1;
          margin-right: 8px;
          padding-bottom: 8px;
        `
      : css`
          flex: 1 0 414px;
          margin-left: 8px;
          padding-bottom: 8px;
        `};
`;

export default {
  GridHolder,
  Grid,
  Column
};
